import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {PageSpeedScoreRenderComponent} from '../../../ng-smart-table-renderers/table-cell-renderers/page-speed-score-render.component';
import {LocalDataSource} from 'ng2-smart-table';
import {PagePathCellRenderComponent} from './page-path-cell-render.component';
import {SitesService} from '../../../services/sites.service';
import {SitePageScoresTableRowModel} from '../../../models/SitePageScoresTableRowModel';
import {SitePagesService} from '../../../services/site-pages.service';
import {GetSitePageResponseDto} from '../../../models/GetSitePageResponseDto';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-site-pages-table',
    templateUrl: './site-pages-table.component.html',
    styleUrls: ['./site-pages-table.component.css']
})
export class SitePagesTableComponent implements OnInit, OnDestroy {

    sitePagesScoresLoadedSubscription: Subscription;
    postSitePageSuccessSubscription: Subscription;
    newlyAddedSitePageScoresReceivedSubscription: Subscription;

    settings = {
        attr: {
            'class': 'table table-striped site-pages-review-scores-table'
        },
        pager: {
            perPage: 15
        },
        actions: false,
        columns: {
            path: {
                title: 'Page',
                filter: false,
                type: 'custom',
                renderComponent: PagePathCellRenderComponent
            },
            'gpd': {
                title: 'GPD',
                filter: false,
                type: 'custom',
                renderComponent: PageSpeedScoreRenderComponent
            },
            'gpm': {
                title: 'GPM',
                filter: false,
                type: 'custom',
                renderComponent: PageSpeedScoreRenderComponent
            },
            'seoIndex': {
                title: 'No Index',
                filter: false
            },
            'seoTitle': {
                title: 'Title',
                filter: false
            },
            'seoFollow': {
                title: 'Follow',
                filter: false
            },
            'seoDescription': {
                title: 'Desciption',
                filter: false
            }
        }
    };
    data: Array<SitePageScoresTableRowModel>;
    source: LocalDataSource;

    constructor(private sitesService: SitesService,
                private sitePagesService: SitePagesService,
                private translateService: TranslateService) {}

    ngOnInit() {
        this.sitePagesScoresLoadedSubscription = this.sitesService.getOnSitePagesScoresLoaded().subscribe(data => {
            this.data = data;
            this.source = new LocalDataSource(this.data);
        });

        this.newlyAddedSitePageScoresReceivedSubscription = this.sitePagesService.getNewlyAddedSitePageScoresReceivedSubject().subscribe(sitePageScoresTableRowModel => {
            this.source.getAll().then(
                (rowsArray) => {
                this.source.update(rowsArray[rowsArray.length - 1], sitePageScoresTableRowModel);
            });
        });

        this.postSitePageSuccessSubscription = this.sitePagesService.getAddSitePageSuccessSubject().subscribe(sitePage => {
            this.source.append(this.createSitePageScoresTableRowModelFromSitePage(sitePage));
        });
    }

    private createSitePageScoresTableRowModelFromSitePage(sitePage: GetSitePageResponseDto): SitePageScoresTableRowModel {
        const row = new SitePageScoresTableRowModel();
        row.pageId = sitePage.id;
        row.path = sitePage.path;
        this.translateService.get('NotAvailableAbbr').subscribe(result => {
             row.gpd = row.gpm = row.seoDescription = row.seoFollow = row.seoIndex = row.seoTitle = result;
        });
        return row;
    }

    ngOnDestroy(): void {
        this.sitePagesScoresLoadedSubscription.unsubscribe();
        this.newlyAddedSitePageScoresReceivedSubscription.unsubscribe();
        this.postSitePageSuccessSubscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/site/site-pages-table/site-pages-table.component.ts